import types from '../mutation-types';
import AiProviderSettingsAPI from '../../api/aiProviderSettings';
import { throwErrorMessage } from '../utils/api';

export const state = {
  record: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isTesting: false,
    isFetchingModels: false,
  },
};

export const getters = {
  getProviderSetting($state) {
    return $state.record;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_AI_PROVIDER_UI_FLAG, { isFetching: true });
    try {
      const response = await AiProviderSettingsAPI.get();
      commit(types.SET_AI_PROVIDER_SETTING, response.data);
    } catch (error) {
      // 404 quando ainda não configurado — ignora
    } finally {
      commit(types.SET_AI_PROVIDER_UI_FLAG, { isFetching: false });
    }
  },

  update: async ({ commit }, data) => {
    commit(types.SET_AI_PROVIDER_UI_FLAG, { isUpdating: true });
    try {
      const response = await AiProviderSettingsAPI.upsert(data);
      commit(types.SET_AI_PROVIDER_SETTING, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_AI_PROVIDER_UI_FLAG, { isUpdating: false });
    }
  },

  testConnection: async ({ commit }, data) => {
    commit(types.SET_AI_PROVIDER_UI_FLAG, { isTesting: true });
    try {
      const response = await AiProviderSettingsAPI.testConnection(data);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: 'unknown' };
    } finally {
      commit(types.SET_AI_PROVIDER_UI_FLAG, { isTesting: false });
    }
  },

  fetchModels: async ({ commit }, data) => {
    commit(types.SET_AI_PROVIDER_UI_FLAG, { isFetchingModels: true });
    try {
      const response = await AiProviderSettingsAPI.fetchModels(data);
      return response.data.models || [];
    } catch (error) {
      throw new Error(
        error?.response?.data?.error || 'Não foi possível buscar os modelos.'
      );
    } finally {
      commit(types.SET_AI_PROVIDER_UI_FLAG, { isFetchingModels: false });
    }
  },
};

export const mutations = {
  [types.SET_AI_PROVIDER_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_AI_PROVIDER_SETTING]($state, data) {
    $state.record = data || {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
